import React, { useEffect } from 'react';
import { getConfig } from '../utils/get-config';
import { loadReCaptcha } from '../utils/load-recaptcha';
import { useDispatch } from 'react-redux';
import { setRecaptchaLoaded } from '../redux/slices/recaptcha.slice';

type Props = {
  children: React.ReactNode;
};

export const RecaptchaProvider: React.FC<Props> = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    async function initRecaptcha() {
      try {
        if (
          window.location.hostname === 'localhost' ||
          window.location.hostname === '127.0.0.1'
        ) {
          console.log('reCAPTCHA desabilitado em localhost');
          dispatch(setRecaptchaLoaded(true));
          return;
        }

        const siteKey = getConfig('REACT_APP_KEY_CAPTCHA');
        await loadReCaptcha(siteKey);
        dispatch(setRecaptchaLoaded(true));
      } catch (err) {
        console.error('Erro ao carregar reCAPTCHA:', err);
        dispatch(setRecaptchaLoaded(false));
      }
    }

    initRecaptcha();
  }, [dispatch]);
  return <>{children}</>;
};
